fx.ns("shared.components", class CoverThumbCalendar extends shared.components.CoverThumb 
{    
    constructor(parameters)
    {
        super(parameters);
    }

    load()
    {
        super.load();

        if (this.element.target == "page") // for page we display calendar
        {
            if (this.element.shape == "desk")
                this.loadImage(window.location.origin + fx.assets.callendarDeskA5.content);
            else
            /*if (this.data.content == "wall-double")
                this.loadImage(window.location.origin + fx.assets.callendarWallA4.content);
            else*/
            if (this.element.shape == "wall-single")
                this.loadImage(window.location.origin + fx.assets.callendarPortrait.content);
            else
                this.ready();
        }
        else
            this.ready();
        
    }

    onImageLoaded()
    {
        this.context.save();

        if (this.element.shape == "desk")
            this.context.drawImage(this.image, this.creationSize.width / 2, 0, this.creationSize.width / 2,  this.creationSize.height);
        else
        /*if (this.data.content == "wall-double")
            this.context.drawImage(this.image, 0, this.creationSize.height/2, this.creationSize.width,  this.creationSize.height/2);
        else*/
        if (this.element.shape == "wall-single")
            this.context.drawImage(this.image, 0, this.creationSize.height/2, this.creationSize.width,  this.creationSize.height/2);
        
        this.context.restore();
        this.ready();
    }
});